const breakpoints = {
  // Min values
  mobile: "480px",
  desktop: "1024px",
};

export const media = {
  portrait: (styles: TemplateStringsArray) => `
    @media screen and (orientation: portrait) and (max-width: ${breakpoints.mobile}) {
        ${styles}
      }
    `,
  desktop: (styles: TemplateStringsArray) => `
    @media screen and (min-width: ${breakpoints.desktop}) {
        ${styles}
      }
    `,
};
